import { createDivIn, createHeaderIn, createImgIn, createLinkIn, createParagraphIn, setElementInnerHTML, setElementOnClick } from '../ui_utils/DomUtils.ts';
import { ReferralProgram } from '../../../../shared/ReferralProgram.ts';
import { LobbyImage } from '@colonist/types';
import { clientI18n } from '../ClientI18n.ts';
import { UIAjaxWrapper } from '../network/UIAjaxWrapper.ts';
import { UIAPIEndpoints } from '../network/UIAPIEndpoints.ts';
import { AudioManager, AudioType } from '@colonist/audio';
import { UIUtilsEjsVariables } from '../UIUtilsEjsVariables.ts';
import { ClientUserState } from '../ClientUserState.ts';
export class UIStoreReferralController {
    async updateReferralProgram() {
        if (this.referralSection != undefined) this.referralSection.classList.remove('hidden');
        if (this.referralSidebarButton != undefined) this.referralSidebarButton.classList.remove('hidden');
        if (this.referralTabMobile != undefined) this.referralTabMobile.classList.remove('hidden');
        const userReferralCount = await UIStoreReferralController.getUserReferralCount();
        this.referralInfoDiv.replaceChildren();
        this.referralItemsDiv.replaceChildren();
        createParagraphIn(this.referralInfoDiv, {
            key: 'strings:storePage.sections.referral.description',
            options: {
                referralCount: userReferralCount,
                context: userReferralCount == 1 ? 'one' : 'other'
            }
        }, '', '');
        this.loadReferralProgramDetails(userReferralCount);
    }
    static async getUserReferralCount() {
        var _ClientUserState_userState, _data_json;
        if (((_ClientUserState_userState = ClientUserState.userState) === null || _ClientUserState_userState === void 0 ? void 0 : _ClientUserState_userState.id) == undefined) return 0;
        const data = await UIAjaxWrapper.getRequestHandler(UIAPIEndpoints.apiGetUserReferralCount(), undefined);
        var _data_json_referralCount;
        return (_data_json_referralCount = data === null || data === void 0 ? void 0 : (_data_json = data.json) === null || _data_json === void 0 ? void 0 : _data_json.referralCount) !== null && _data_json_referralCount !== void 0 ? _data_json_referralCount : 0;
    }
    createBaseView() {
        const contentDiv = createDivIn(this.referralItemsDiv, 'store_page_item');
        const bodyDiv = createDivIn(contentDiv, 'store_page_item_body');
        const headerDiv = createDivIn(contentDiv, 'store_page_item_header');
        return {
            contentDiv: contentDiv,
            headerDiv: headerDiv,
            bodyDiv: bodyDiv
        };
    }
    static createButton(contentDiv, referralReward, userReferralCount) {
        const button = createLinkIn(contentDiv, '#', {
            key: 'strings:colonistCommon.utils.emptyString'
        }, 'store_button');
        const buttonText = UIStoreReferralController.isRewardAlreadyUnlocked(userReferralCount, referralReward.referralCount) ? UIStoreReferralController.markAsUnlocked(button, contentDiv) : UIStoreReferralController.markAsToBeUnlocked(button, referralReward.referralCount);
        return button;
    }
    static createTitleAndImage(headerDiv, bodyDiv, referralReward) {
        const title = createHeaderIn(headerDiv, referralReward.name, '', '', 'H3');
        if (!UIUtilsEjsVariables.isUserOnMobile) createImgIn(title, LobbyImage.InfoIcon);
        const image = createImgIn(bodyDiv, referralReward.image);
        return image;
    }
    static createDescription(bodyDiv, referralReward) {
        const description = createParagraphIn(bodyDiv, {
            key: 'strings:colonistCommon.utils.emptyString'
        }, '');
        description.style.display = 'none';
        setElementInnerHTML(description, {
            key: 'strings:colonistCommon.utils.#buffer',
            options: {
                value: UIStoreReferralController.loadReferralItemDescription(referralReward)
            }
        });
        return description;
    }
    addReferralButtonOnClickBehavior(button, userReferralCount, referralReward) {
        setElementOnClick(button, ()=>{
            if (UIStoreReferralController.isRewardAlreadyUnlocked(userReferralCount, referralReward.referralCount)) return;
            AudioManager.play(AudioType.Click);
            void this.storeBodyController.onInviteFriendsButtonClick(referralReward, userReferralCount);
        }, true);
    }
    static loadReferralItemDescription(referralReward) {
        let description = clientI18n.t('strings:storePage.sections.referral.details', {
            context: referralReward.possibleRewards.length === 1 ? 'one' : 'many'
        }) + '<br>';
        referralReward.possibleRewards.forEach((possibleReward)=>{
            description += `<br>- ${clientI18n.t(possibleReward.name.key)}`;
        });
        return description;
    }
    static markAsToBeUnlocked(button, referralCount) {
        createParagraphIn(button, {
            key: 'strings:storePage.sections.referral.action.toBeUnlocked',
            options: {
                referralCount: referralCount,
                context: referralCount == 1 ? 'one' : 'other'
            }
        }, '', '');
    }
    static markAsUnlocked(button, contentDiv) {
        createParagraphIn(button, {
            key: 'strings:storePage.sections.referral.action.unlocked'
        }, '', '');
        contentDiv.className = 'store_page_item item_owned';
    }
    static isRewardAlreadyUnlocked(userReferralCount, rewardReferralCount) {
        if (userReferralCount >= rewardReferralCount) return true;
        return false;
    }
    static displayDescriptionInsteadOfImage(description, image) {
        description.style.display = 'block';
        image.style.display = 'none';
    }
    static displayImageInsteadOfDescription(description, image) {
        description.style.display = 'none';
        image.style.display = 'block';
    }
    static isDescriptionAlreadyDisplayed(description) {
        return description.style.display == 'block';
    }
    static isClickOnTheItem(event, contentDiv) {
        return contentDiv.contains(event.target);
    }
    loadReferralProgramDetails(userReferralCount) {
        const referralProgram = ReferralProgram.referralRewardLevels;
        referralProgram.forEach((referralReward)=>{
            const { contentDiv, headerDiv, bodyDiv } = this.createBaseView();
            const button = UIStoreReferralController.createButton(contentDiv, referralReward, userReferralCount);
            const image = UIStoreReferralController.createTitleAndImage(headerDiv, bodyDiv, referralReward);
            const description = UIStoreReferralController.createDescription(bodyDiv, referralReward);
            const clickableDiv = UIUtilsEjsVariables.isUserOnMobile ? bodyDiv : contentDiv;
            this.storeBodyController.setupReferralRewardClickHandler(clickableDiv, description, image, referralReward);
            this.addReferralButtonOnClickBehavior(button, userReferralCount, referralReward);
        });
    }
    constructor(storeBodyController){
        this.storeBodyController = storeBodyController;
        var _document_getElementById;
        this.referralSection = (_document_getElementById = document.getElementById('referrals')) !== null && _document_getElementById !== void 0 ? _document_getElementById : document.querySelector('.m-store-referral');
        this.referralItemsDiv = document.getElementById('store_page_referral_items');
        this.referralInfoDiv = document.getElementById('store_page_referral_info');
        this.referralSidebarButton = document.getElementById('referral_sidebar_button');
        this.referralTabMobile = document.getElementById('m-store-button-rewards');
    }
}
